import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, PurchaseData, LogsData, CountData } from './types'

export const selectPurchaseListEvent = (state: RootState): Event => state.purchaseReducer.listEvent

export const selectPurchaseList = (state: RootState): ListData => state.purchaseReducer.list

export const selectPurchaseActionEvent = (state: RootState): Event => state.purchaseReducer.actionEvent

export const selectPurchaseDetail = (state: RootState): PurchaseData | undefined =>
  state.purchaseReducer.detail

export const selectPurchaseDetailEvent = (state: RootState): Event => state.purchaseReducer.detailEvent

export const selectLogsEvent = (state: RootState): Event => state.purchaseReducer.logsEvent

export const selectLogs = (state: RootState): LogsData[] => state.purchaseReducer.logs

export const selectCountData = (state: RootState): CountData | undefined => state.purchaseReducer.countData
